import React, { useState } from 'react';
import Modal from '../../common/Modal';
import Button from '../../common/Button';
import { useToast } from '../../../hooks/useToast';

const ReopenTicketModal = ({ isOpen, onClose, onSubmit, ticket }) => {
  const [reopenReason, setReopenReason] = useState('');
  const { error } = useToast();

  const handleConfirm = () => {
    if (!reopenReason.trim()) {
      error('Please provide a reason for reopening');
      return;
    }
    onSubmit(ticket.id, { reason: reopenReason.trim() });
  };

  const handleClose = () => {
    setReopenReason('');
    onClose();
  };

  const footer = (
    <>
      <Button variant="secondary" onClick={handleClose}>Cancel</Button>
      <Button variant="primary" onClick={handleConfirm}>Reopen Ticket</Button>
    </>
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title={`Reopen Ticket #${ticket?.id || ''}`}
      size="medium"
      footer={footer}
    >
      <div style={{ marginBottom: '16px', color: 'var(--text-secondary)', fontSize: '14px' }}>
        Provide a reason for reopening this ticket.
      </div>
      <div>
        <label style={{ fontSize: '13px', fontWeight: '600', color: 'var(--text-primary)', marginBottom: '8px', display: 'block' }}>
          Reason for Reopening
        </label>
        <textarea 
          value={reopenReason} 
          onChange={(e) => setReopenReason(e.target.value)} 
          placeholder="Describe why this ticket needs to be reopened..." 
          style={{ width: '100%', minHeight: '140px', padding: '12px', borderRadius: '8px', border: '1px solid var(--border)', background: 'var(--background)', color: 'var(--text-primary)', fontSize: '14px', fontFamily: 'inherit', resize: 'vertical' }} 
        />
      </div>
    </Modal>
  );
};

export default ReopenTicketModal;
